/*
Fasteners

  --type <string::enum> | ['Bed Rail', 'Biscuit', 'Keyhole', 'Clips', 'Tite Joint']
  --pair <boolean::switch> | ['Pair', 'Individual']
*/

import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'

export default [
  ...hardwareFormFields,
  {
    key: 'type',
    value: 'type',
    type: 'select',
    required: true,
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Type',
      required: true,
      class: ['input--dense']
    },
    values: ['Bed Rail', 'Biscuit', 'Keyhole', 'Clips', 'Tite Joint']
  },
  {
    key: 'pair',
    value: 'pair',
    type: 'radio',
    required: true,
    default: 'Pair',
    classes: ['xs12', 'sm4', 'input__wrapper', 'input__wrapper--centered'],
    attributes: {
      label: 'Pair',
      required: true,
      class: ['input--dense']
    },
    values: [
      {
        label: 'Pair',
        value: 'Pair'
      },
      {
        label: 'Individual',
        value: 'Individual'
      }
    ]
  }
]
